// extracted by mini-css-extract-plugin
module.exports = {"BulkActions":"BulkActions_BulkActions__3z-D-"};